import { render, staticRenderFns } from "./TopicPlusNav.vue?vue&type=template&id=76fda052&scoped=true"
import script from "./TopicPlusNav.vue?vue&type=script&lang=js"
export * from "./TopicPlusNav.vue?vue&type=script&lang=js"
import style0 from "./TopicPlusNav.vue?vue&type=style&index=0&id=76fda052&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76fda052",
  null
  
)

export default component.exports